import { ReactNode } from 'react';

export const usersHeaders = [
  'user',
  'email',
  'userTypeId',
  'userTag',
  'parentUserId',
  'userStatus',
  'kycStatus',
  'createdDate',
  'actions',
] as const;

export type TUserHeadersKeys = (typeof usersHeaders)[number];

export const allUsersHeadersList: TUserHeadersKeys[] = [...usersHeaders];

export type TUserRowType = {
  [key in TUserHeadersKeys | 'actions']: ReactNode;
};
